var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStartoverIcon = function SvgStartoverIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F9FA",
    d: "M15.313 2.683a.834.834 0 0 1 1.353.65v13.334a.833.833 0 0 1-1.353.65L6.98 10.65a.833.833 0 0 1 0-1.3zm-11.146.65c.46 0 .833.374.833.834v11.666a.834.834 0 0 1-1.666 0V4.167c0-.46.372-.834.833-.834"
  })));
};
export default SvgStartoverIcon;